<template>
  <el-table-column
    prop="city"
    sortable="custom"
    label="Város"
    min-width="150"
    show-overflow-tooltip=""
  >
    <template slot-scope="scope">
      {{ scope.row.city }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
